import {
  put, takeLatest, all, select, call,
} from 'redux-saga/effects';
import { exception } from 'circe/logger';
import { fetch, fetched } from './actions';
import * as api from './api';
import { getCurrency } from '../../fuse/preferences/currency';

function* doFetch(action) {
  const { payload } = action;
  const { ownerId } = payload;
  const state = yield select();
  const currency = getCurrency(state);

  try {
    const results = yield call(api.fetch, ownerId);
    yield put(
      fetched(
        results.map((term) => ({
          ...term,
          currency,
        })),
      ),
    );
  } catch (e) {
    exception(e);
  }
}

function* watcher() {
  yield all([takeLatest(fetch().type, doFetch)]);
}

export default watcher;
